import React, { useEffect, useState } from 'react'
import ReactLoading from "react-loading";

function LazyLoader() {
    return (
        <>
            <div className='lazy-loader'>
                <ReactLoading
                    type="spin"
                    color="white"
                    height={"2%"}
                    width={"2%"}
                />
            </div>

        </>
    )
}

export default LazyLoader